import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar/Sidebar';
import Topbar from '../../components/Topbar/Topbar';
import RightSidebar from '../../components/RightSidebar/RightSidebar';
import './Jobs.css';

import API_URL from '../../config';


/* ── Feather-style SVG icons ─────────────────── */
const Icons = {
  home: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  messageSquare: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
  mail: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  briefcase: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>,
  grid: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>,
  folder: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>,
  settings: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  search: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  plus: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  mapPin: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  clock: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  users: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  dollarSign: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  x: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  calendar: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  send: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
  check: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>,
  trash: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>,
  chevronDown: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>,
  eye: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>,
  logOut: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
};

/* ── Helpers ───────────────────────────────────── */
const timeAgo = (dateStr) => {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'Az önce';
  if (mins < 60) return `${mins} dk önce`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs} saat önce`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days} gün önce`;
  return `${Math.floor(days / 30)} ay önce`;
};

const formatDate = (d) => d ? new Date(d).toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' }) : '';

const typeLabels = { fulltime: 'Tam Zamanlı', freelance: 'Freelance', tender: 'İhale' };
const typeFilters = [
  { key: 'all', label: 'Tümü' },
  { key: 'fulltime', label: 'Tam Zamanlı' },
  { key: 'freelance', label: 'Freelance' },
  { key: 'tender', label: 'İhale' },
];

const Jobs = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [theme] = useState(() => localStorage.getItem('projabze_theme') || 'dark');

  /* ── Jobs state ── */
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedJob, setSelectedJob] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);

  /* ── Filters ── */
  const [typeFilter, setTypeFilter] = useState('all');
  const [cityFilter, setCityFilter] = useState('');
  const [keyword, setKeyword] = useState('');

  /* ── Create modal ── */
  const [showCreate, setShowCreate] = useState(false);
  const [formData, setFormData] = useState({ title: '', description: '', type: 'fulltime', city: '', budgetMin: '', budgetMax: '', expiresAt: '' });
  const [formLoading, setFormLoading] = useState(false);
  const [formError, setFormError] = useState('');

  /* ── Applications (for poster) ── */
  const [applications, setApplications] = useState([]);
  const [appsLoading, setAppsLoading] = useState(false);

  /* ── Mobile sidebar ── */
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const token = localStorage.getItem('projabze_token');
  const detailRef = useRef(null);

  /* ── Auth check ── */
  useEffect(() => {
    const stored = localStorage.getItem('projabze_user');
    if (stored) {
      setUser(JSON.parse(stored));
    } else {
      navigate('/');
    }
  }, [navigate]);

  /* ── Fetch jobs ── */
  const fetchJobs = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (typeFilter !== 'all') params.append('type', typeFilter);
      if (cityFilter) params.append('city', cityFilter);
      params.append('sort', 'newest');
      const res = await fetch(`${API_URL}/api/jobs?${params.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setJobs(Array.isArray(data) ? data : (data.jobs || []));
      }
    } catch { /* network error */ }
    setLoading(false);
  }, [typeFilter, cityFilter, token]);

  useEffect(() => { if (user) fetchJobs(); }, [user, fetchJobs]);

  /* ── Fetch single job detail ── */
  const fetchJobDetail = async (id) => {
    setDetailLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/jobs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setSelectedJob(data.job || data);
      }
    } catch { /* ignore */ }
    setDetailLoading(false);
  };

  /* ── Fetch applications (poster) ── */
  const fetchApplications = async (jobId) => {
    setAppsLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/jobs/${jobId}/applications`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setApplications(Array.isArray(data) ? data : (data.applications || []));
      }
    } catch { /* ignore */ }
    setAppsLoading(false);
  };

  /* ── Select a job ── */
  const selectJob = (job) => {
    setSelectedJob(job);
    setApplications([]);
    fetchJobDetail(job._id || job.id);
    if (detailRef.current) detailRef.current.scrollTop = 0;
  };

  /* ── Apply ── */
  const handleApply = async () => {
    if (!selectedJob) return;
    const id = selectedJob._id || selectedJob.id;
    try {
      const res = await fetch(`${API_URL}/api/jobs/${id}/apply`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      if (res.ok) {
        fetchJobDetail(id);
        fetchJobs();
      }
    } catch { /* ignore */ }
  };

  /* ── Update application status (poster) ── */
  const updateAppStatus = async (appId, status) => {
    if (!selectedJob) return;
    const jobId = selectedJob._id || selectedJob.id;
    try {
      const res = await fetch(`${API_URL}/api/jobs/${jobId}/applications/${appId}`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ status }),
      });
      if (res.ok) {
        fetchApplications(jobId);
      }
    } catch { /* ignore */ }
  };

  /* ── Delete job ── */
  const handleDelete = async () => {
    if (!selectedJob) return;
    const id = selectedJob._id || selectedJob.id;
    try {
      const res = await fetch(`${API_URL}/api/jobs/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        setSelectedJob(null);
        fetchJobs();
      }
    } catch { /* ignore */ }
  };

  /* ── Create job ── */
  const handleCreate = async (e) => {
    e.preventDefault();
    if (!formData.title || !formData.description || !formData.city) {
      return setFormError('Başlık, açıklama ve şehir zorunludur.');
    }
    setFormLoading(true);
    setFormError('');
    try {
      const body = {
        title: formData.title,
        description: formData.description,
        type: formData.type,
        city: formData.city,
        budgetMin: formData.budgetMin ? Number(formData.budgetMin) : undefined,
        budgetMax: formData.budgetMax ? Number(formData.budgetMax) : undefined,
        expiresAt: formData.expiresAt || undefined,
      };
      const res = await fetch(`${API_URL}/api/jobs`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (res.ok) {
        setShowCreate(false);
        setFormData({ title: '', description: '', type: 'fulltime', city: '', budgetMin: '', budgetMax: '', expiresAt: '' });
        fetchJobs();
      } else {
        const data = await res.json();
        setFormError(data.message || 'İlan oluşturulamadı.');
      }
    } catch {
      setFormError('Sunucuya ulaşılamadı.');
    }
    setFormLoading(false);
  };

  /* ── Keyboard ── */
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') { setShowCreate(false); setSidebarOpen(false); } };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, []);

  if (!user) return null;

  const initials = (user.firstName?.[0] || '') + (user.lastName?.[0] || '');
  const userId = user._id || user.id;

  /* poster check */
  const isPoster = selectedJob && (
    (selectedJob.poster?._id || selectedJob.poster?.id || selectedJob.poster) === userId
  );
  const hasApplied = selectedJob?.applicants?.includes(userId) ||
    selectedJob?.applications?.some(a => (a.user?._id || a.user?.id || a.user) === userId) ||
    selectedJob?.hasApplied;

  /* keyword filter (client-side) */
  const filteredJobs = jobs.filter(j => {
    if (!keyword) return true;
    const kw = keyword.toLowerCase();
    return (j.title || '').toLowerCase().includes(kw) || (j.description || '').toLowerCase().includes(kw);
  });

  const handleLogout = () => {
    localStorage.removeItem('projabze_token');
    localStorage.removeItem('projabze_user');
    navigate('/');
  };

  return (
    <div className={`jobs-page ${theme}`}>
      <Topbar user={user} onLogout={handleLogout} />

      {/* ─── SIDEBAR ─── */}
      <Sidebar activeId="jobs" user={user} onLogout={handleLogout} className={sidebarOpen ? 'open' : ''} />

      {/* Mobile overlay */}
      {sidebarOpen && <div className="jobs-sidebar-overlay" onClick={() => setSidebarOpen(false)} />}

      {/* ─── MAIN: JOB LIST ─── */}
      <main className="jobs-main">
        {/* Mobile hamburger */}
        <button className="jobs-mobile-menu" onClick={() => setSidebarOpen(true)}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
        </button>

        {/* Header */}
        <div className="jobs-main-header">
          <div>
            <h1>İş İlanları</h1>
            <p>Elektrik mühendisliği projeleri ve iş fırsatları</p>
          </div>
          <button className="jobs-create-btn" onClick={() => setShowCreate(true)}>
            <span className="jobs-create-btn-icon">{Icons.plus}</span>
            <span>İlan Oluştur</span>
          </button>
        </div>

        {/* Filters */}
        <div className="jobs-filters">
          <div className="jobs-filter-tabs">
            {typeFilters.map(f => (
              <button
                key={f.key}
                className={`jobs-filter-tab ${typeFilter === f.key ? 'active' : ''}`}
                onClick={() => setTypeFilter(f.key)}
              >
                {f.label}
              </button>
            ))}
          </div>
          <div className="jobs-filter-inputs">
            <div className="jobs-search-box">
              <span className="jobs-search-icon">{Icons.search}</span>
              <input
                type="text"
                placeholder="Anahtar kelime ara..."
                value={keyword}
                onChange={e => setKeyword(e.target.value)}
              />
            </div>
            <div className="jobs-city-box">
              <span className="jobs-city-icon">{Icons.mapPin}</span>
              <input
                type="text"
                placeholder="Şehir"
                value={cityFilter}
                onChange={e => setCityFilter(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Job list */}
        <div className="jobs-list">
          {loading ? (
            <div className="jobs-loading">
              <div className="jobs-spinner" />
              <span>İlanlar yükleniyor...</span>
            </div>
          ) : filteredJobs.length === 0 ? (
            <div className="jobs-empty">
              <div className="jobs-empty-icon">{Icons.briefcase}</div>
              <h3>İlan bulunamadı</h3>
              <p>Filtreleri değiştirin veya yeni bir ilan oluşturun.</p>
            </div>
          ) : (
            filteredJobs.map(job => {
              const jId = job._id || job.id;
              const isActive = selectedJob && (selectedJob._id || selectedJob.id) === jId;
              const poster = job.poster || {};
              const posterName = poster.firstName ? `${poster.firstName} ${poster.lastName || ''}`.trim() : 'Anonim';
              const posterInitials = (poster.firstName?.[0] || '?') + (poster.lastName?.[0] || '');
              return (
                <div
                  key={jId}
                  className={`jobs-card ${isActive ? 'active' : ''}`}
                  onClick={() => selectJob(job)}
                >
                  <div className="jobs-card-top">
                    <h3 className="jobs-card-title">{job.title}</h3>
                    <span className={`jobs-type-badge ${job.type}`}>{typeLabels[job.type] || job.type}</span>
                  </div>
                  <div className="jobs-card-poster">
                    <div className="jobs-avatar-xs">
                      {poster.avatar ? <img src={API_URL + poster.avatar} alt="" /> : posterInitials}
                    </div>
                    <span className="jobs-card-poster-name">{posterName}</span>
                  </div>
                  <div className="jobs-card-meta">
                    {job.city && (
                      <span className="jobs-card-meta-item">{Icons.mapPin} {job.city}</span>
                    )}
                    {(job.budgetMin || job.budgetMax) && (
                      <span className="jobs-card-meta-item">
                        {Icons.dollarSign}
                        {job.budgetMin ? `${job.budgetMin.toLocaleString('tr-TR')}` : '?'}
                        {' - '}
                        {job.budgetMax ? `${job.budgetMax.toLocaleString('tr-TR')} TL` : '?'}
                      </span>
                    )}
                    <span className="jobs-card-meta-item">{Icons.users} {job.applicationCount ?? job.applicants?.length ?? 0} başvuru</span>
                    <span className="jobs-card-meta-item">{Icons.clock} {timeAgo(job.createdAt)}</span>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </main>

      {/* ─── RIGHT SIDEBAR ─── */}
      <RightSidebar />

      {/* ─── CREATE MODAL ─── */}
      {showCreate && (
        <div className="jobs-modal-overlay" onClick={e => { if (e.target.classList.contains('jobs-modal-overlay')) setShowCreate(false); }}>
          <div className="jobs-modal">
            <div className="jobs-modal-header">
              <h2>İlan Oluştur</h2>
              <button className="jobs-modal-close" onClick={() => setShowCreate(false)}>{Icons.x}</button>
            </div>
            <form className="jobs-modal-form" onSubmit={handleCreate}>
              <div className="jobs-form-group">
                <label>Başlık</label>
                <input
                  type="text"
                  placeholder="örn. Endüstriyel Tesis Elektrik Projesi"
                  value={formData.title}
                  onChange={e => setFormData(p => ({ ...p, title: e.target.value }))}
                />
              </div>
              <div className="jobs-form-group">
                <label>Açıklama</label>
                <textarea
                  rows={4}
                  placeholder="İş ilanı detayları, gereksinimler..."
                  value={formData.description}
                  onChange={e => setFormData(p => ({ ...p, description: e.target.value }))}
                />
              </div>
              <div className="jobs-form-row">
                <div className="jobs-form-group">
                  <label>Tür</label>
                  <select value={formData.type} onChange={e => setFormData(p => ({ ...p, type: e.target.value }))}>
                    <option value="fulltime">Tam Zamanlı</option>
                    <option value="freelance">Freelance</option>
                    <option value="tender">İhale</option>
                  </select>
                </div>
                <div className="jobs-form-group">
                  <label>Şehir</label>
                  <input
                    type="text"
                    placeholder="İstanbul"
                    value={formData.city}
                    onChange={e => setFormData(p => ({ ...p, city: e.target.value }))}
                  />
                </div>
              </div>
              <div className="jobs-form-row">
                <div className="jobs-form-group">
                  <label>Min Bütçe (TL)</label>
                  <input
                    type="number"
                    placeholder="10000"
                    value={formData.budgetMin}
                    onChange={e => setFormData(p => ({ ...p, budgetMin: e.target.value }))}
                  />
                </div>
                <div className="jobs-form-group">
                  <label>Max Bütçe (TL)</label>
                  <input
                    type="number"
                    placeholder="50000"
                    value={formData.budgetMax}
                    onChange={e => setFormData(p => ({ ...p, budgetMax: e.target.value }))}
                  />
                </div>
              </div>
              <div className="jobs-form-group">
                <label>Son Başvuru Tarihi</label>
                <input
                  type="date"
                  value={formData.expiresAt}
                  onChange={e => setFormData(p => ({ ...p, expiresAt: e.target.value }))}
                />
              </div>
              {formError && <div className="jobs-form-error">{formError}</div>}
              <button className="jobs-btn-primary full" type="submit" disabled={formLoading}>
                {formLoading ? 'Oluşturuluyor...' : 'İlanı Yayınla'}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Jobs;
